// 🔧 contact.js
// ✅ Purpose: Public contact page for Let's Go Vote
// ✅ Features:
// - SEO Helmet metadata
// - Provides direct contact information
// - Reuses footer contact form component
// - Links users to request event page

import React from "react";
import { Link } from "react-router-dom";
import FooterWithContactForm from "../../components/FooterWithContactForm";
import SeoHead from "../../components/seo_head";
import { PUBLIC_PAGE_SEO } from "../../constants/marketing_pages";

const Contact = () => {
  return (
    <>
      <SeoHead {...PUBLIC_PAGE_SEO.contact} />

      <section id="top-content" className="container-fluid py-5">
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-8 text-start">
              <div className="text-uppercase text-primary fw-bold mb-2">
                Contact
              </div>

              <h1 className="display-4 fw-bold mb-3">
                Contact Let's Go Vote
              </h1>

              <p className="lead text-muted">
                Questions about using Let's Go Vote for your event?
                Send us a message or request your event.
              </p>

              <Link to="/request_event" className="btn btn-primary btn-lg">
                Request Your Event
              </Link>
            </div>
          </div>

          <div className="white-section p-4 rounded shadow-sm bg-white text-start mb-4">
            <h2 className="h4 mb-3">Email</h2>
            <p className="mb-0">
              hello@letsgovote.app
            </p>
          </div>

          <div className="white-section p-4 rounded shadow-sm bg-dark text-white text-start">
            <h2 className="h4 mb-3">Send a message</h2>
            <FooterWithContactForm />
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
